// DS: i6.20
import React from 'react';
import IconWrap from '../../IconWrap';
const Image = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-1 2H4v10.27l1.879-1.877a1 1 0 011.32-.083l.094.083 2.78 2.781-2.674 2.825h2.753l6.883-7.271.092-.086a.995.995 0 01.237-.145.997.997 0 01.75.272l.037.038L20 13.97V19l-7.103-.002.001.002H20V5zm-8.5 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
        clipRule: "evenodd"
    })));
};
Image.displayName = 'Image';
export default Image;
